const gaps = [
  {
    title: 'Постановка задач',
    desc: 'Руководитель может знать правила постановки задач, но продолжать давать сотрудникам размытые поручения.',
  },
  {
    title: 'Делегирование',
    desc: 'Может знать теорию делегирования, но продолжать делать всё самостоятельно.',
  },
  {
    title: 'Обратная связь',
    desc: 'Может знать правила обратной связи, но избегать сложных разговоров.',
  },
];

export default function WhatAreCompetencies() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что такое управленческие компетенции
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Управленческие компетенции — это не набор теоретических знаний о менеджменте. Это способность руководителя применять конкретные инструменты управления в реальных рабочих ситуациях и получать необходимый результат через команду.
        </p>

        <div className="bg-white rounded-2xl border border-gray-200 p-6 md:p-10 max-w-4xl mx-auto mb-12 text-center">
          <p className="text-base md:text-xl text-gray-900 leading-relaxed font-semibold">
            Знать инструмент ≠ уметь применять инструмент.
          </p>
        </div>

        <div className="grid sm:grid-cols-1 lg:grid-cols-3 gap-5 mb-12">
          {gaps.map((g) => (
            <div key={g.title} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <h3 className="font-bold text-gray-900 text-sm mb-2">{g.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{g.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto">
          <p className="text-base text-teal-800 leading-relaxed font-semibold text-center">
            Поэтому развитие компетенций должно включать не только обучение, но и практику, внедрение и обратную связь.
          </p>
        </div>
      </div>
    </section>
  );
}